import {PlayerArea} from '@/components/main/MyPlus/common/PlayerArea';
import useMainStore from '@/stores/main';
import {useEffect} from 'react';
import {MAIN_LIST_CNT} from '@/constants/main';
import {buildTopLiveList} from '@/utils/main/my-plus/topLiveListUtils';

const PreviewContentType = ({
  data,
  selectedMode,
  hiddenStreamer,
  isSimplifyMode,
  isLoading,
}) => {
  const {banner, topLiveList, isShowMainBanner, setTopLiveList} =
    useMainStore();

  useEffect(() => {
    if (data) {
      const filteredList = data
        .filter((item) => !hiddenStreamer.includes(item.userId))
        .slice(0, MAIN_LIST_CNT);

      const filteredTopList = buildTopLiveList({
        selectedMode,
        broadList: filteredList,
        isSimplifyMode,
        topLiveList,
        banner,
      });

      setTopLiveList(filteredTopList);
    }
  }, [data, isSimplifyMode, banner, selectedMode]);

  return (
    <section>
      {!isShowMainBanner && (
        <PlayerArea
          banner={banner.main}
          selectedMode={selectedMode}
          isLoading={isLoading}
        />
      )}
    </section>
  );
};

export default PreviewContentType;
